import { FC } from 'react';
import { Typography } from '../../../ui/typography/Typography';
import { useIsMobile } from '../../../utils/getIsMobile';
import { useTranslation } from '../../../utils/useTranslation';

export const FeedTitle: FC<{ hasItems: boolean }> = ({ hasItems }) => {
    const t = useTranslation();
    const isMobile = useIsMobile();

    return (
        <Typography weight="bold" variant="title2" p={4} pl={isMobile ? 2 : 0}>
            {hasItems ? t('Вам может понравиться') : ''}
        </Typography>
    );
};
